// extracted by mini-css-extract-plugin
module.exports = {"freez":"AdStyle_freez__EaNnF","largeRectangleAd":"AdStyle_largeRectangleAd__2ZYdn","ad_position":"AdStyle_ad_position__1UMAc","largeRectAd":"AdStyle_largeRectAd__pOBVh"};